<template>
  <main-table-layout
      :id="$route.params.id"
      :has-top-bar="false"
      :init-drag-zone-width="15"
      :overflow-auto="false"
      back-button-tab-selector="sfxbackbutton"
      sub-menu-selector="librarypanel"
      tab-selector="assemblytab"
      @endDrag="endDrag"
  >
    <portal-target slot="filter" name="filterPortal"/>
    <template slot="outerLeftContent">
      <div class="dflex pl-4 mt-3">
        <label :for="'showPreview' + $vnode.key" class="container"
        >{{ $t("showPreview") }}
          <input
              :id="'showPreview' + $vnode.key"
              v-model="showPreview"
              type="checkbox"
          />
          <span class="checkmark"></span>
        </label>
      </div>
      <div :class="['babylon-viewer-export-profile bg-dark', showPreview ? 'open' : 'closed']">
        <!--<div class="lasche" @click="showPreview = !showPreview">{{ $t('Preview') }}</div>-->
        <babylon
            v-if="previewId && previewAssetId && showPreview"
            ref="babylon"
            :asset-id="previewAssetId"
            :instance-id="previewId"
            :storage-source="previewType === 'node' ? 'Instance' : 'Asset'"
            class="babylon"
            source="Instance"
        />
      </div>
    </template>

    <div v-if="hasAccess" slot="mainContent"
         class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <div class="ml-3">
          <h1>
            <icon class="mr-2" type="cubes"/>
            {{ $store.getters.getSfxdataName($route.params.id) }}
          </h1>
        </div>
      </div>
      <div class="col-12 col-lg-9 pr-0">
        <integrated-export-profiles
            ref="integratedExportProfiles"
            :key="forceReRenderKey"
            :assembly-id="$route.params.id"
            :input-units="inputUnits"
            :linked-export-profiles="linkedExportProfiles"
            :organization-id="$store.getters.getSfxdataOrganization($route.params.id)"
            :project-id="projectId"
            :root-node="rootNode"
            @currentlyEditing="setCurrentlyEditingFilter"
            @instanceUpdated="(val) => {updateCacheInstances(val)}"
            @instanceDeleted="(val) => {updateCacheInstances(val)}"
        />
      </div>
      <div class="col-12 col-lg-3 pl-0 pr-0 mt-5">
        <tree-view
            v-if="projectId && hasAccess && currentlyEditingFilter"
            :class="[activeTab + '-mode', 'position-sticky export-profile-tree']"
            :enable-filtering="!!currentlyEditingFilter"
            :highlighted-items="$store.getters.getAssemblyItemsInstancesFiltered({
              listName: projectId,
              asKeys: false,
              filterId: currentlyEditingFilter,
              filterType: 'Filter',
              instances: $store.getters.getAssemblyFullitems(projectId)
            })"
            :merged-instance-ids="$store.getters.getAssemblyItemsInstancesFiltered({
              listName: projectId,
              asKeys: true,
              filterId: currentlyEditingFilter,
              filterType: 'Merge',
              instances: $store.getters.getAssemblyFullitems(projectId)
            })"
            :mode="$store.getters.getExportFilterModeById(currentlyEditingFilter)"
            :project-id="projectId"
            :show-select-box="true"
            :string-array="$store.getters.getExportFilterStringById(currentlyEditingFilter)"
            :meta-filter="$store.getters.getExportFilterById(currentlyEditingFilter)"
            @setPreviewId="setPreviewId"
        />
      </div>
      <div class="w-100"/>
      <div v-if="hasAccess" class="col-12">
        <info-panel
            v-if="processingFilterItem"
            :collapsible="true"
            :initially-collapsed="false"
            class="mt-3 new-style"
            info-panel-header="Preview"
            preview-id="processForm"
        >
          <div slot="info">
            <filter-trigger-form
                v-if="projectId && rootNode && processingFilterItem"
                :key="forceReRenderKey + 200"
                :filter-item="processingFilterItem"
                :input-units="inputUnits"
                :instance-id="updateInstanceId"
                :project-id="projectId"
                :root-node="rootNode.id"
                @abort="processingFilterItem = ''; updateInstanceId = ''; updateAssetId = ''"
                @started="processingFilterItem = ''; forceReRenderKey++;"
            />
          </div>
        </info-panel>
      </div>
      <loading-panel v-if="loading" slot="fullContent" class="row"/>
      <div v-if="!hasAccess && !loading" slot="fullContent" class="row">
        <div class="col-12">
          {{ $t('NoExportProfileAccess') }}
        </div>
      </div>
    </div>
  </main-table-layout>
</template>

<script>
import Icon from "@/components/Icon.vue";
import MainTableLayout from "@/layouts/MainTableLayout.vue";
import InfoPanel from "@/components/InfoPanel";
import DateMixin from "@/components/mixins/DateMixin.js";
import Babylon from "../components/preview/Babylon";
import TreeView from "../components/tree/TreeView";
import {SpecialUuids} from "@/enum";
import {sleep} from "@/utils";
import LoadingPanel from "@/components/LoadingPanel.vue";
import FilterTriggerForm from "@/components/sfxFilter/FilterTriggerForm.vue";
import IntegratedExportProfiles from "@/components/exportProfiles/IntegratedExportProfiles.vue";

export default {
  name: "SFXLinkedData",
  components: {
    Babylon,
    MainTableLayout,
    InfoPanel,
    FilterTriggerForm,
    TreeView,
    LoadingPanel,
    IntegratedExportProfiles,
    Icon,
  },
  mixins: [DateMixin],
  data() {
    return {
      inputUnits: null,
      updateInstanceId: null,
      showPreview: false,
      activeTab: 'filter',
      loading: false,
      organizationId: '',
      metaSets: [],
      metaSetName: '',
      projectId: '',
      currentlyEditingFilter: '',
      processingFilterItem: '',
      forceReRenderKey: 0,
      hasAccess: false,
      hasProcessRunning: false,
      rootNode: '',
      previewId: null,
      previewAssetId: null,
      previewType: "",
      linkedExportProfiles: []
    };
  },
  computed: {
    editFormShowing() {
      return (!!this.currentlyEditingFilter);
    },
    startFormShowing() {
      return !!this.processingFilterItem;
    }
  },
  beforeMount() {
    this.loading = true;
    this.id = this.$route.params.id;
    this.init();
  },
  methods: {
    setCurrentlyEditingFilter(val) {
      if(this.currentlyEditingFilter === val) {
        this.currentlyEditingFilter = null;
      } else {
        this.currentlyEditingFilter = val;
      }
    },
    async updateCacheInstances(instanceIds) {
      await sleep(500);
      await this.$store.dispatch('clientPatchAssemblyProjectInstancesCaching', {
        id: this.projectId,
        args: {instanceIds}
      });
      await this.$store.dispatch('createNotification', {
        text: 'Cache updated',
      })
      if(this.$refs.integratedExportProfiles) {
        this.$refs.integratedExportProfiles.reloadItem();
      }
    },
    async init() {
      console.log('init', this.id);
      return await this.$store.dispatch('loadSfxdata', {
        id: this.id,
        addPipelineState: true,
        include: ['teams', 'metaValues', 'taskManagerRow', 'instances']
      }).then(async data => {
        const {metaValues, taskManagerRows, sourceProjectId, organizationId, instances} = data;
        console.log('instances', instances);
        this.linkedExportProfiles = await this.exportProfileInstanceIdsUsedInProjects(instances);
        // todo here
        this.projectId = sourceProjectId;
        this.organizationId = organizationId;
        this.hasAccess = this.$store.getters.isSuperAdmin ? true : await this.$store.dispatch('checkIfExportProfileFeature', {organizationId: this.organizationId});
        this.loading = false;
        await this.setRootNode();
        this.hasProcessRunning = taskManagerRows && taskManagerRows.length;
        this.setInputUnits(metaValues);
      }).catch(e => {
        if (e.status === 401) {
          this.$router.push('/access-denied');
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    async exportProfileInstanceIdsUsedInProjects(instances) {
      const linkedExportProfiles = [];
      for (let i = 0; i < instances.length; i++) {
        const {metaFields, projectId} = instances[i];
        console.log('metaFields', metaFields);
        if (metaFields && metaFields.length) {
          const index = metaFields.findIndex(item => {
            return item.id === SpecialUuids.EXPORT_PROFILE_METAFIELD;
          })
          console.log('index', index);
          if (index !== -1) {
            const exportProfileInstanceId = metaFields[index].metaValues[0].value;
            linkedExportProfiles.push({
              projectId,
              exportProfileInstanceId
            });
          }
        }
      }
      // todo: load project names here
      const uniqueProjectIds = [...new Set(linkedExportProfiles.map(item => item.projectId))];
      console.log('uniqueProjectIds', uniqueProjectIds);
      if (uniqueProjectIds.length) {
        await this.$store.dispatch('clientLoadProjects', {
          filter: 'id in ' + "'" + uniqueProjectIds.join("' '") + "'"
        }).then(projects => {
          console.log('projects', projects);
          linkedExportProfiles.forEach(item => {
            const project = projects.find(p => p.id === item.projectId);
            if (project) {
              item.projectName = project.name;
            }
          })
        })
      }
      return linkedExportProfiles;
    },
    setInputUnits(metaValues) {
      if (metaValues && metaValues.length) {
        const index = metaValues.findIndex(item => {
          return item.metaFieldId === SpecialUuids.ASSEMBLY_UNIT_METAFIIELD;
        })
        if (index !== -1) {
          this.inputUnits = metaValues[index].value;
        }
      }
    },
    async updateFilterInstance(instanceId, assetId) {
      console.log('updateFilterInstance', instanceId, assetId);
      this.updateInstanceId = instanceId;
      await this.$store.dispatch('loadFilter', {
        id: assetId
      }).then(async filter => {
        await this.updateCacheInstances([instanceId]);
        this.processingFilterItem = filter;
      })
    },
    endDrag() {
      this.$refs.babylon.endDrag();
    },
    setActiveTab(activeTab) {
      this.activeTab = activeTab;
    },
    setPreviewId(item) {
      if (!item) {
        return;
      }
      this.previewId = item.id;
      this.previewAssetId = item.assetId;
      this.previewType = item.type;
    },
    async setRootNode() {
      return await this.$store.dispatch('clientLoadProjectInstances', {
        id: this.projectId,
        filter: 'type in node model, level eq 1, parentId eq null'
      }).then(rootNode => {
        if (rootNode && rootNode[0] && rootNode[0].id) {
          const root = rootNode[0];
          const {id, assetId} = root;
          this.rootNode = root;
          this.previewId = id;
          this.previewType = 'node';
          this.previewAssetId = assetId;
        }
      })
    },
    finishEditing() {
      this.currentlyEditingFilter = '';
      this.forceReRenderKey++;
    },
  },
}
</script>
<style lang="scss">
.export-profile-tree {
  top: 0;
}
.babylon-viewer-export-profile {
  /*position:fixed;
  bottom:0;
  left:0;*/
  width: 90%;
  padding-top: 90%;
  margin: auto;
  z-index: 1500;
  border-radius: 4px;
  -webkit-box-shadow: 6px -7px 6px -5px #2c2b2b;
  box-shadow: 6px -7px 6px -5px #2C2B2BFF;
  border: 1px solid #313131;
  position: relative;

  .babylon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &.closed {
    left: -150%;
  }

  &.big {
    width: 600px;
    height: 600px;
  }

  .lasche {
    position: absolute;
    right: -50px;
    top: 25px;
    padding: 5px;
    border-radius: 2px;
    transform: rotate(90deg);
    cursor: pointer;
    background: var(--vform-editor-ui-secondary-color);
    transition: all 300ms ease;
    box-shadow: #0f0f10 5px 5px 6px;

    &:hover {
      background: var(--vform-editor-ui-tertiary-color);
      color: #000;
    }
  }
}

// iPad landscape
@media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (min-device-height: 768px) and (max-device-height: 768px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .export-profile-right, .export-profile-left {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>